import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconHairdryer: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.1 4L6 3C3.8 3 2 4.8 2 7v4c0 1.9 1.4 3.5 3.2 3.9l1.4 4.9C7 21.1 8.2 22 9.5 22c.9 0 1.8-.4 2.3-1.1.6-.7.8-1.7.5-2.6l-1.2-3.8L16 14c.5-.1.9-.5.9-1V5c.1-.5-.3-.9-.8-1zM4 11V7c0-1.1.9-2 1.9-2H6v8c-1.1 0-2-.9-2-2zm6.4 7.8c.1.3 0 .6-.2.8-.1.3-.4.4-.7.4-.4 0-.8-.3-.9-.7l-1.3-4.4 1.9-.2 1.2 4.1zm4.6-6.7l-7 .7V5.2l7 .7v6.2zM19 8h2c.6 0 1-.4 1-1s-.4-1-1-1h-2c-.6 0-1 .4-1 1s.4 1 1 1zm0 2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2c-.6 0-1-.4-1-1s.4-1 1-1z',
    })
  )
}
